import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'next/link';
import Icon from '../Icon';
import ManualSearch from '../ManualSearch';
import styles from './ManualHeader.module.scss';

const ManualHeader = ({
    backLink = null,
    logoHref = '/',
    searchPlaceholder = 'Search',
    manualId = null,
}) => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const searchRef = useRef(null);
    const hasSearch = !!manualId;

    const toggleSearch = () => {
        const nextIsOpen = !isSearchOpen;
        setIsSearchOpen(nextIsOpen);

        if (nextIsOpen) {
            requestAnimationFrame(() =>
                searchRef.current?.querySelector('input')?.focus()
            );
        }
    };

    return (
        <header className={styles['ManualHeader']}>
            <div className={styles['ManualHeader__Container']}>
                {!!backLink?.href && (
                    <Link
                        href={backLink.href}
                        aria-label={backLink.title}
                        className={styles['ManualHeader__BackLink']}>
                        <Icon
                            type="chevronThinLeftWhite"
                            modifiers={['ManualHeaderBack']}
                        />
                        <span className={styles['ManualHeader__BackText']}>
                            {backLink.title}
                        </span>
                    </Link>
                )}

                {hasSearch && (
                    <button
                        type="button"
                        className={styles['ManualHeader__SearchToggle']}
                        aria-label={searchPlaceholder}
                        aria-expanded={isSearchOpen}
                        onClick={toggleSearch}>
                        <Icon
                            type={isSearchOpen ? 'cross' : 'search'}
                            modifiers={['White', 'ManualHeaderSearchToggle']}
                        />
                    </button>
                )}

                <Link
                    href={logoHref}
                    className={styles['ManualHeader__Logo']}
                    aria-label="nordkeyboards.com">
                    <Icon
                        type="nordWordmarkWhite"
                        modifiers={['ManualHeaderLogo']}
                    />
                </Link>

                {hasSearch && (
                    <div
                        className={classNames(styles['ManualHeader__Search'], {
                            [styles['ManualHeader__Search--Open']]: isSearchOpen,
                        })}
                        ref={searchRef}>
                        <ManualSearch
                            manualId={manualId}
                            placeholder={searchPlaceholder}
                        />
                    </div>
                )}
            </div>
        </header>
    );
};

ManualHeader.propTypes = {
    backLink: PropTypes.shape({
        title: PropTypes.string,
        href: PropTypes.string,
    }),
    logoHref: PropTypes.string,
    searchPlaceholder: PropTypes.string,
    manualId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ManualHeader;
